import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './TextInputMP.scss';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onEnterTriggerBlur: PropTypes.bool,
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.string
};

const defaultProps = {
  onEnterTriggerBlur: true,
  autoComplete: 'off',
  autoFocus: false
};

const TextInputMP = (props, context) => {
  const options = {};
  if (props.onEnterTriggerBlur === true) {
    options.onKeyDown = e => {
      if (props.onBlur && e.key === 'Enter') {
        props.onBlur({ target: { value: props.value } });
      }
    };
  }

  return (
    <div className={`textInputMP ${props.className}`}>
      <input
        name="search"
        type="textbox"
        placeholder={props.placeholder}
        className="search__bar-input"
        onChange={props.onChange}
        value={props.value}
        onBlur={props.onBlur || (() => {})}
        onFocus={e => e.target.select()}
        autoFocus={props.autoFocus === true}
        autoComplete={props.autoComplete}
        {...options}
      />
    </div>
  );
};

TextInputMP.propTypes = propTypes;
TextInputMP.defaultProps = defaultProps;
export default TextInputMP;
